import React, { useState, useEffect, Link } from "react";
import axios from "axios";
import { Cookies } from "../../index.js";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { alert_error, alert_success } from "../../AppContext";
import AdSense from 'react-adsense';
import { useSelector, useDispatch } from 'react-redux';
import Ticket_holder from './ticket_holder';
import { Tooltip } from "react-tooltip";
import Category from './category';
import Orders_option from '../../shop/ai/orders/orders_option.jsx';
import Orders_option_main from './orders_option.jsx';
import Language_i18 from './../../js/useNationalLanguage.jsx';

import { update_username_orders, update_services_categorys, update_amount_orders, update_discount_orders, update_money_orders, update_comments_orders } from './actions';

function Ordergoogle({ input_url_orders, set_input_url_orders, isDisabled, setIsDisabled }) {
    const { i18n, lang } = Language_i18();
    const items = useSelector(state => state.items);
    const money_orders = useSelector(state => state.money_orders);
    const amount_orders = useSelector(state => state.amount_orders);
    const discount_orders = useSelector(state => state.discount_orders);
    const services_categorys = useSelector(state => state.services_categorys);
    const services_orders = useSelector(state => state.services_orders);
    const comments_orders = useSelector(state => state.comments_orders);
    const username_orders = useSelector(state => state.username_orders);
    const price_orders = useSelector(state => state.price_orders);
    const isHustMediaTele = services_orders?.type?.includes("hust_media_tele")
        || services_orders?.category?.includes("hust_media_tele");
    const dispatch = useDispatch();

    const set_services_categorys = (value) => {
        dispatch(update_services_categorys(value));
    };
    const set_username_orders = (value) => {
        dispatch(update_username_orders(value));
    };
    const set_comments_orders = (value) => {
        dispatch(update_comments_orders(value));
    };
    const set_money_orders = (value) => {
        dispatch(update_money_orders(value));
    };
    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };
    const set_discount_orders = (value) => {
        dispatch(update_discount_orders(value));
    };
    const [codeSnippet, setcodeSnippetd] = useState(`<div id="hustmedia"></div>
<script src='https://hust.media/api/website/main.js?v=4&chedo=1'></script>`);
    const [username, setusername] = useState("");
    const [nutorder, setnutorder] = useState("✔️ Click to Confirm");
    const [nutxuly, setnutxuly] = useState(0);
    const [chedo, setchedo] = useState("");
    const [money, setmoney] = useState(null);
    const [commentsok, setcommentsok] = useState("");
    const [isOpen, setIsOpen] = useState(true);
    const [isOpen2, setIsOpen2] = useState(true);
    const [service2, setservice2] = useState(true);
    const navigate = useNavigate();
    const handleTextareaChange = (event) => {
        const text = event.target.value;
        if (services_orders?.category?.includes("hust_media_tele")) {
            set_comments_orders(text);
            setcommentsok(text);
            set_amount_orders(1);
            services_math_1(1);
            return;
        }
        // split into lines
        const lines = text.split('\n');
        // turn into a JSON array string
        const formattedJson = JSON.parse(JSON.stringify(lines));
        console.log(formattedJson);
        // store the JSON string in comments_orders
        set_comments_orders(formattedJson);
        // store the raw text if you still need it
        setcommentsok(text);
    };

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };
    const handleCommentsChange = () => {
        if (isHustMediaTele) {
            set_amount_orders(1);
            services_math_1(1);
            return;
        }
        const amountok = commentsok
            .split("\n")
            .filter(line => line.trim() !== "")   // loại bỏ dòng trống
            .length;

        set_amount_orders(amountok);
        services_math_1(amountok);
    };
    useEffect(() => {
        handleCommentsChange();
    }, [commentsok]);
    useEffect(() => {
        if (isHustMediaTele) {
            set_amount_orders(1);
            services_math_1(1);
        }
    }, [isHustMediaTele]);
    const [options, setoptions] = useState([
        {
            id: "",
            stt: "",
            name: "Please wait a moment 😊 đang tải dịch vụ",
            money: "",
            status: "show",
            content: "",
            servicecode: "",
        },
    ]);

    const [options2s, setOptions2s] = useState([
        { label: 'Level User 1 - 40s - 150xu', value: '40', money: '150' },
        { label: 'Level User 2 - 70s - 200xu', value: '70', money: '200' },
        { label: 'Level User 3 - 100s - 250xu', value: '100', money: '250' },
    ]);
    const handleOptionChange2 = (event) => {
        const selectedOption = event.target.value;

        setchedo(selectedOption);
        console.log(selectedOption);
    };

    function services_math_2(amountok, rate) {
        const giagiamok = rate * amountok * discount_orders / 100;
        const giaok = rate * amountok - giagiamok;
        setmoney(giaok);
        const giaokRounded = parseFloat(giaok.toFixed(2)); // Làm tròn đến 2 chữ số thập phân
        set_money_orders(giaokRounded);
    }

    function services_math_1(amountok) {
        console.log(service2.money);
        if (services_orders.category == 'transfer_coins') {
            if (discount_orders > 2) {
                set_discount_orders(2);
                services_math_2(amountok, services_orders.money);
            }
            else {
                services_math_2(amountok, services_orders.money);
            }
        } else if (services_orders.category == 'accounts_seller') {
            if (price_orders > 8) {
                set_discount_orders(8);
                services_math_2(amountok, services_orders.money * price_orders);
            }
        } else if (services_orders.typeapi == 'p2p_mmo') {
            services_math_2(amountok, services_orders.money * price_orders);
        }
        else if (services_orders.category == 'savings_orders') {
            set_discount_orders(0);
            services_math_2(amountok, services_orders.money);
        }
        else if (services_orders.category == 'search') {
            services_math_2(amountok, service2.money);
        }
        else {
            services_math_2(amountok, services_orders.money);
        }
    }

    function services_math_3(countValue, priceValue) {
        const countNum = Number(countValue) || 0;
        const priceNum = Number(priceValue) || 0;
        const basePrice = Number(services_orders?.money ?? 0);
        const total = countNum * priceNum + basePrice;
        if (services_orders?.typeapi === 'p2p_mmo') {
            const rate = Number(services_orders?.money) || 0;
            if (!rate || !priceNum) {
                services_math_1(0);
                return;
            }
            const effectiveAmount = total / (rate * priceNum);
            services_math_1(effectiveAmount);
            return;
        }
        const rate = Number(services_orders?.money) || 1;
        const effectiveAmount = total / rate;
        services_math_1(effectiveAmount);
    }

    function laydulieu() {
        const apikey = Cookies.get("apikey");
        axios
            .post("https://hust.media/api/wallet/laychietkhau.php?apikey=" + apikey)
            .then((response) => set_discount_orders(response.data))
            .catch((error) => console.log(error));
    }
    function testFunction(response) {
        const info = response.data;
        const orderok = info.order;
        const error = info.error;
        setnutorder("đặt tiếp luôn nào");
        setnutxuly(0);
        if (error) {
            alert_error(info.error);
        } else if (orderok) {
            alert_success('Thankiuu Bạn là người thứ ' + orderok + ' ủng hộ Hust Media');
        }
        else {
            alert_error('Lỗi không xác định vui lòng liên hệ admin');
        }
        if (info.redirect != null && info.redirect != "") {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    }

    const loimatroi = (error) => {
        alert_error(error);
        setnutorder("Thử lại xem");
        setnutxuly(0)
    };
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleFocus2 = () => {
        setIsOpen2(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleBlur2 = () => {
        setIsOpen2(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };
    const handleMenuOpen2 = () => {
        setIsOpen2(true);
    };
    const handleChange2 = (selectedOption2) => {
        setusername(selectedOption2.value);
        setIsOpen2(false);
        setservice2(selectedOption2);
        services_math_2(amount_orders, selectedOption2.money);
    };
    function saochep(value) {
        alert_success("Đã sao chép");
        window.saochepnative(value);
    }


    useEffect(() => {
        laydulieu();
        set_amount_orders('');
    }, []);
    const platforms = [
        { name: 'TikTok', value: 'tiktok' },
        { name: 'Facebook', value: 'facebook' },
        { name: 'YouTube', value: 'youtube' },
        { name: 'Instagram', value: 'insta' }
    ];

    const handleSelection = (platform) => {
        set_comments_orders(platform);
    };
    const emotions = [
        { id: 1, imgSrc: 'https://tecom.pro/img/icon/like (1).svg', alt: 'LIKE' },
        { id: 2, imgSrc: 'https://tecom.pro/img/icon/care.svg', alt: 'CARE' },
        { id: 3, imgSrc: 'https://tecom.pro/img/icon/love (1).svg', alt: 'LOVE' },
        { id: 4, imgSrc: 'https://tecom.pro/img/icon/haha.svg', alt: 'HAHA' },
        { id: 5, imgSrc: 'https://tecom.pro/img/icon/wow.svg', alt: 'WOW' },
        { id: 6, imgSrc: 'https://tecom.pro/img/icon/sad.svg', alt: 'SAD' },
        { id: 7, imgSrc: 'https://tecom.pro/img/icon/angry.svg', alt: 'ANGRY' }
    ];
    const [selectedEmotion, setSelectedEmotion] = useState(null);

    const handleSelect = (emotion) => {
        if (selectedEmotion == emotion.id) {
            setSelectedEmotion('');
            set_comments_orders('');
        }
        else {
            setSelectedEmotion(emotion.id);
            set_comments_orders(emotion.alt);
            // alert(emotion.alt);
        }
    };
    const { content } = services_orders || {};

    // Xử lý fallback:
    // - Nếu content là object (ví dụ { vi: '...', en: '...' }) thì lấy theo lang
    // - Nếu content[lang] không tồn tại thì fallback về content['vi']
    // - Nếu content vốn đã là string (HTML chung) thì dùng nguyên
    const html = (() => {
        if (content == null || String(content).trim().length === 0) {
            return '';
        }
        if (typeof content === 'object') {
            // content là object { vi: '...', en: '...' }
            return (content[lang] || content['en'] || '').trim();
        }
        if (typeof content === 'string') {
            // content là string, có thể là JSON hoặc HTML chuỗi
            try {
                const parsed = JSON.parse(content);
                if (typeof parsed === 'object') {
                    return (parsed[lang] || parsed['en'] || '').trim();
                }
            } catch {
                // alert('không phải JSON');
            }
            return content.trim();
        }
        return '';
    })();

    return (
        <>
            {services_orders.content && (
                <>
                    <div className="text-sm" dangerouslySetInnerHTML={{ __html: html }}></div>
                </>
            )}
            {(services_orders && services_orders.type && services_orders.type.includes("hust_ai")) ? (
                <Orders_option
                    input_url_orders={input_url_orders}
                    set_input_url_orders={set_input_url_orders}
                    services_math_1={services_math_1}
                    services_math_3={services_math_3}
                    isDisabled={isDisabled}
                    commentsok={commentsok}
                    handleTextareaChange={handleTextareaChange} />
            ) : services_orders.id && (
                <>
                    {services_orders && services_orders.type && services_orders.type.includes("Comment Likes") && (
                        <>
                            <label className="text-sm">Username of the comment owner</label>
                            <br />
                            <div className="input-group flex-nowrap">
                                <span className="input-group-text" id="addon-wrapping">
                                    acc
                                </span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Điền username sở hữu bình luận"
                                    aria-label="input_url_orders"
                                    value={comments_orders}
                                    name="comments_orders"
                                    aria-describedby="addon-wrapping"
                                    onChange={(e) => set_comments_orders(e.target.value)}
                                />
                            </div>
                        </>
                    )}
                    {services_orders && services_orders.type && services_orders.type.includes("reaction") && (
                        <>
                            <div className="mt-1 flex justify-center items-center space-x-4">
                                {emotions.map((emotion) => (
                                    <div key={emotion.id} onClick={() => handleSelect(emotion)} className="flex flex-col items-center">
                                        <img
                                            src={emotion.imgSrc}
                                            alt={emotion.alt}
                                            className={`w-10 h-10 ${selectedEmotion === emotion.id ? 'opacity-100' : 'opacity-50'}`}
                                        />
                                        <input
                                            type="checkbox"
                                            checked={selectedEmotion === emotion.id}
                                            className="mt-2"
                                        />
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                    <label className="mt-0 mb-0 flex justify-center items-center">Số lượng tăng</label>
                    <div className="input-group flex-nowrap">
                        <input
                            onChange={(e) => {
                                if (isHustMediaTele) {
                                    set_amount_orders(1);
                                    services_math_1(1);
                                    return;
                                }
                                set_amount_orders(e.target.value);
                                services_math_1(e.target.value);
                            }}
                            value={amount_orders}
                            type="text"
                            className="form-control mb-0"
                            placeholder="Nhập số lượng mong muốn"
                            aria-label="inputcaption"
                            name="inputcaption"
                            aria-describedby="addon-wrapping"
                        ></input>
                    </div>
                    {services_orders.time &&
                        (<>
                            <div className="mt-0 flex  justify-center items-center space-x-2">
                                <div className="flex text-base text-gray-800">
                                    time ước tính
                                    <div
                                        className="text-blue-500 cursor-help"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content="Time trung bình 5 đơn hàng gần nhất trên 500 đơn vị"
                                    >  &nbsp;!</div>
                                </div>
                                <Tooltip className="max-w-xs mx-auto mb-0 break-all" id="my-tooltip" />
                                <input
                                    type="text"
                                    value={services_orders.time}
                                    className="mt-0.5 p-0.5 bg-gray-100 rounded-md w-40 text-base text-gray-600 text-center"
                                    readOnly
                                />
                            </div>
                        </>)
                    }
                    <div className="mt-0 flex  justify-center items-center">
                        <div className="text-xs mt-[-0.5px] ">
                            Tối thiểu {services_orders.minorder} &emsp; Tối đa {services_orders.maxorder}
                        </div>
                    </div>
                    {services_orders && services_orders.type && services_orders.type.includes("search") && (
                        <>

                            <div className="input-group flex-nowrap">
                                <input
                                    onChange={(e) => {
                                        set_comments_orders(e.target.value);
                                    }}
                                    value={comments_orders}
                                    type="text"
                                    className="form-control mb-0"
                                    placeholder="Từ khóa cần seo"
                                    aria-label="inputcaption"
                                    name="inputcaption"
                                    aria-describedby="addon-wrapping"
                                ></input>   </div>
                            <label className="text-sm">Chọn level của bạn</label>
                            <Select
                                className="mb-1"
                                classNamePrefix="Chọn 1 lựa chọn"
                                onFocus={handleFocus2}
                                options={options2s}
                                menuIsOpen={isOpen2}
                                onBlur={handleBlur2}
                                onMenuOpen={handleMenuOpen2}
                                onChange={handleChange2} // Use selectedOption.value to get the selected value
                                isDisabled={false}
                                isLoading={false}
                                isClearable={true}
                                isRtl={false}
                                isSearchable={false}
                            />
                        </>

                    )}
                </>
            )}
            {services_orders && services_orders.type && services_orders.type.includes("website") && (
                <>
                    <div className="mt-2 mb-2 bg-gray-900 px-2 py-1 rounded-lg relative">
                        <div className="flex items-center justify-between ">
                            <div className="text-sm mb-1 text-gray-400 ">Đoạn code gắn vào Footer web đích</div>
                            <div className="flex space-x-1">
                                <button
                                    type="button"
                                    className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                                    onClick={() => saochep(codeSnippet)}
                                >
                                    Copy
                                </button>
                                <a href="https://t.me/hustmedia" target="_blank" className="ml-auto">
                                    <button
                                        type="button"
                                        className="text-xs bg-blue-500 hover:bg-blue-600 text-white font-bold py-1 px-2 rounded focus:outline-none focus:ring focus:ring-blue-300"
                                    >
                                        Support
                                    </button>
                                </a>
                            </div>
                        </div>
                        <pre className="whitespace-pre-wrap text-gray-300">{codeSnippet}</pre>
                    </div>

                </>
            )}

            <Orders_option_main input_url_orders={input_url_orders}
                set_input_url_orders={set_input_url_orders}
                commentsok={commentsok}
                handleTextareaChange={handleTextareaChange}
                services_math_1={services_math_1}
                isDisabled={isDisabled}
            />
            {services_orders && services_orders.type && services_orders.type.includes("report_social") && (
                <>
                    <div className="mx-auto flex flex-col items-center justify-center">
                        <h2 className="text-xl text-gray-800 mb-1">Chọn một nền tảng:</h2>
                        <div className="grid grid-cols-2 gap-2">
                            {platforms.map((platform) => (
                                <div
                                    key={platform.value}
                                    className={`py-2 px-4 rounded ${comments_orders === platform.value ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-800'}`}
                                    onClick={() => handleSelection(platform.value)}
                                >
                                    {platform.name}
                                </div>
                            ))}
                        </div>
                        <div className="mt-0">
                            <p className="text-gray-600">Đã chọn: {comments_orders}</p>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default Ordergoogle;
